import React, { Component } from 'react';
import { Form, Empty, message } from 'antd';
import "../index.less"
import TabsControl from './TabSwitch'
import { config, postFrom } from '../../../../../../axios';
import { moneyAddComma } from '../../../../../../utils/index';
import { dicPayType, ReceivablesType, backMoneyType } from '../../../../../../axios/dictionaries'
import moment from 'moment';
import Detail from '../../../../../Bill/components/Receiv/Detail';
import PaymentDetail from '../../../../../Bill/components/Payment/Detail';
import TableDOM from '../../../../../../components/Table';

class BillMessage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            InputWidth: "185px",
            shortInputWidth: "135px",
            data: [],
            billType: 1, //默认为收款账单
            showDetailModal: false, //显示收款详情
            showPaymentDetailModal: false, //显示退款详情

            current: 1, //当前页
            tableLoading: false,
            tableTotal: 0,
        }
    }

    componentDidMount() {
        this.handleSearch();
    }

    handleSearch = (values = {}) => { //receiveOrPay 1 收款账单  /  receiveOrPay 2 退款账单
        this.setState({ tableLoading: true });
        postFrom({
            url: config.API_rentcontract_getRentContractByIdBillMsg,
            data: {
                rentContractId: this.props.id,
                receiveOrPay: this.state.billType,
                ...values
            }
        }).then(res => {
            this.setState({ data: res.records, tableTotal: res.total, current: res.current, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取信息失败');
            this.setState({ loading: false });
        });
    }

    handleChange = (index) => {
        this.setState({ data: [], billType: index }, () => {
            this.handleSearch()
        })
    }

    handleShowDetail = (id) => { //显示详情
        this.setState({ showDetailModal: true });
        this.detailRef.loadPackage(id);
    }

    handleShowPaymentDetail = (id) => { //显示详情
        this.setState({ showPaymentDetailModal: true });
        this.paymentDetailRef.loadPackage(id);
    }

    render() {
        let {
            showDetailModal,
            showPaymentDetailModal,
            data,
            tableLoading,
            tableTotal,
            current,
        } = this.state;

        return (
            <div>
                <div className="custom" >
                    <TabsControl specClick={this.handleChange} >
                        <div name="收款账单" >
                            <TableDOM
                                columns={columns({ handleShowDetail: this.handleShowDetail })}
                                data={data}
                                loading={tableLoading}
                                total={tableTotal}
                                current={current}
                                onChange={this.handleSearch}
                            />
                            <Detail
                                onRef={ref => this.detailRef = ref}
                                visible={showDetailModal}
                                handleCancel={() => { this.setState({ showDetailModal: false }) }}
                            />

                        </div>
                        <div name="退款账单" >
                            <TableDOM
                                columns={columns2({ handleShowPaymentDetail: this.handleShowPaymentDetail })}
                                data={data}
                                loading={tableLoading}
                                total={tableTotal}
                                current={current}
                                onChange={this.handleSearch}
                            />
                            <PaymentDetail
                                onRef={ref => this.paymentDetailRef = ref}
                                visible={showPaymentDetailModal}
                                handleCancel={() => { this.setState({ showPaymentDetailModal: false }) }}
                            />
                        </div>
                    </TabsControl>
                </div>
            </div>
        )
    }
}

const columns = ({ handleShowDetail }) => [
    {
        title: '应收日期',
        dataIndex: 'mustPayDate',
        render(text) {
            return text ? moment(text).format('YYYY-MM-DD') : null
        }
    },
    {
        title: '账单名称',
        dataIndex: 'feeName',
    },
    {
        title: '账单周期',
        dataIndex: 'billBeginDate',
        render(text, record) {
            return <span>{text ? moment(text).format('YYYY-MM-DD') : null} 至 {record.billEndDate ? moment(record.billEndDate).format('YYYY-MM-DD') : null}</span>
        }
    },
    {
        title: '应收 | 已收（元）',
        dataIndex: 'billMoney',
        render(text, record) {
            return <span>
                <div>{moneyAddComma(text)}</div>
                <div style={{ color: "red" }}>{moneyAddComma(record.receivedMoney)}</div>
            </span>
        }
    },
    {
        title: '账单状态 | 结清日期',
        dataIndex: 'historyBill',
        render(text, record) {
            let value = ReceivablesType.find(item => item.value === record.receiveStatus);
            return <span>
                <div>{record.historyBill ? '历史迁移' : value ? value.title : ''}</div>
                <div>{record.receiveStatus === 3 && record.finishDate ? moment(record.finishDate).format('YYYY-MM-DD') : null}</div>
            </span>
        }
    },
    {
        title: '操作',
        dataIndex: 'action',
        render(text, record, index) {
            return (
                <div className="table-action">
                    <span className="showClickDetail" onClick={() => { handleShowDetail(record.id) }} >详情</span>
                </div>
            )
        }
    }
];

const columns2 = ({ handleShowPaymentDetail }) => [
    {
        title: '应退日期',
        dataIndex: 'mustPayDate',
        render(text) {
            return text ? moment(text).format('YYYY-MM-DD') : null
        }
    },
    {
        title: '退款原因',
        dataIndex: 'feeRemark',
    },
    {
        title: '应退金额（元）',
        dataIndex: 'billMoney',
        render(text, record) {
            return <span>{moneyAddComma(text)}</span>
        }
    },
    {
        title: '退款方式',
        dataIndex: 'endPayType',
        render(text) {
            let value = backMoneyType.find(item => item.value === text);
            if (value) {
                return value.title
            }
            return ''
        }
    },
    {
        title: '退款状态',
        dataIndex: 'payStatus',
        render(text) {
            return <span>{text === 1 ? '未完成' : '已完成'}</span>
        }
    },
    {
        title: '完成日期',
        dataIndex: 'finishDate',
        render(text) {
            return <span>{text ? moment(text).format('YYYY-MM-DD') : null}</span>
        }
    },
    {
        title: '操作',
        dataIndex: 'action',
        render(text, record, index) {
            return (
                <div className="table-action">
                    <span className="showClickDetail" onClick={() => { handleShowPaymentDetail(record.id) }} >详情</span>
                </div>
            )
        }
    }
];

export default Form.create()(BillMessage)


// WEBPACK FOOTER //
// ./src/page/RentContract/components/List/details/BillMessage/index.js